<template>
  <div class="forgot-password-component">
    <a-button type="link" ghost class="back-button" @click="onCancelClick">
      <chevron-left-icon></chevron-left-icon>
      Terug
    </a-button>

    <h2 class="title color-white mb-md">
      Wachtwoord vergeten
    </h2>

    <div v-if="!requestedPasswordReset">
      <p class="color-white mb-xs">Gebruikersnaam</p>

      <p class="mb-md">
        <a-input ref="username" v-model="username"
                 v-on:keyup.enter.native.prevent="onRequestPasswordResetClick"
                 v-bind:class="{'has-error': !usernameValid}"
                 @focus="() => {usernameValid = true}"
                 @blur="validateUsername"
        />
        <span v-if="!usernameValid" class="error-message">Gebruikersnaam niet geldig.</span>
      </p>
      <p class="color-white pb-md">
        We sturen je een mail met een link waarmee je je wachtwoord kunt resetten.
      </p>
      <p>
        <a-button :loading="requestingPasswordReset" size="large" type="primary" block
                  @click="onRequestPasswordResetClick">
          Wachtwoord herstel aanvragen
        </a-button>
      </p>
    </div>
    <div v-if="requestedPasswordReset">
      <p class="color-white">
        Klopt de ingevoerde gebruikersnaam?
      </p>

      <p class="color-white">
        Dan hebben we je een mail gestuurd met instructies voor het resetten van de wachtwoord.
      </p>

      <br/>

      <p class="color-white">
        Weet je niet zeker of je gebruikersnaam klopt, klik dan op de link hieronder.
      </p>
    </div>

    <a-button type="link" block ghost @click="onForgotUsernameClick">
      Gebruikersnaam vergeten
    </a-button>
  </div>
</template>

<script>
import authApi from "~/api/auth";

export default {
  name: "ForgotPasswordComponent",
  props: {
    defaultUsername: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      username: '',
      requestingPasswordReset: false,
      requestedPasswordReset: false,
      requestingUsernameReminder: false,
      usernameValid: true,
      passwordValid: true,
      emailValid: true,
    }
  },
  computed: {
    defaultRememberUsername() {
      return this.defaultUsername !== null;
    }
  },
  methods: {
    validateUsername(e) {
      this.usernameValid = (this.username.trim().length > 2);
    },
    onRequestPasswordResetClick() {
      this.validateUsername();

      if (this.usernameValid === true) {
        this.requestingPasswordReset = true;
        authApi.requestPasswordReset(this.username).then(response => {
          // this.loggingIn = false;
          this.requestingPasswordReset = false;
          this.requestedPasswordReset = true;
          this.handlePasswordSuccess();
        }).catch(error => {
          this.requestingPasswordReset = false;
          this.factor = null;
          this.password = '';
          this.$refs.password.focus(); // FIXME?
          this.handlePasswordResetError(error);
        });
      }
    },
    onForgotUsernameClick() {
      this.$emit('forgot-username');
    },
    onCancelClick() {
      this.$emit('cancel');
    },
    handlePasswordSuccess() {
      this.$emit('success');
    },
    handlePasswordResetError(error) {
      this.$notification['error']({
        message: 'Er is iets fout gegaan',
      });
    },
  },
  mounted() {
    this.username = this.defaultUsername;
    setTimeout(() => {
      this.$refs.username.focus();
    }, 500);
  }
}
</script>

<style scoped>
.auth-panel {
  background-color: #1a4b6c;
  color: white;
}

.side-image {
  background-size: cover;
  background-position: center left;
}

.auth-panel .content {
  padding: 3rem 4rem;
  min-height: 35rem;
}

.forgot-password-component .title {
  font-size: 3rem !important;
  color: white !important;
}

.auth-panel .steps {
  margin: -1rem 0rem 1rem 0rem;
  color: rgba(255, 255, 255, 0.5);
}

.auth-panel .steps .active {
  color: white;
}

.forgot-password-component .back-button {
  margin-left: -18px;
  margin-bottom: 18px;
}

.has-error {
  border-color: #ff4040;
  box-shadow: 0 0 0 2px rgba(255, 24, 24, 0.2);
}

.error-message {
  color: rgba(255, 24, 24, 0.9);
}
</style>
